<template>
    <span
        class="Tag"
        :class="type"
    >
        <slot />
    </span>
</template>
<script>

export default {
    props: {
        type: {
            type: String,
            default: 'default',
            validator: (val) => ['default', 'success', 'warning'].includes(val)
        }
    }
}
</script>
<style lang="scss">
.Tag {
    border-radius: 9px;
    padding: 3px 5px;
    color: $color-white;
    font-size: 12px;
    line-height: 14px;
    font-weight: normal;

    &.warning {
        background: linear-gradient(45deg, #FF8C98 0%, #FFC080 100%);
    }

    &.success {
        background: linear-gradient(266.35deg, #00D7CA 3.55%, #00D7A3 86.37%);
    }

    &.default {
        background: white;
        color: $color-f2m-purple-icon;
        border: 1px solid $color-f2m-purple-icon;
    }
}
</style>
